import { render, staticRenderFns } from "./Uspto.vue?vue&type=template&id=04e6a60e&"
import script from "./Uspto.vue?vue&type=script&lang=js&"
export * from "./Uspto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports